<script setup lang="ts">
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useMapSettingsStore } from '@/stores/mapSettingsStore.ts'
import ToggleSwitch from '@/components/Elements/ToggleSwitch/ToggleSwitch.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const mapSettings = useMapSettingsStore()
</script>

<template>
  <SmallModel :title="t('map.settings.title')">
    <StandardCard class="p-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.scanRange.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.scanRange.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showScanRange" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.mouseWheelZoom.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.mouseWheelZoom.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.enableMouseWheelZoom" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.hideBackground.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.hideBackground.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.hideBackgroundImage" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.rememberTooltip.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.rememberTooltip.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.rememberTooltipPosition" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.showActionPaths.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.showActionPaths.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showAllShipActionPaths" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.showPatrolRoutes.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.showPatrolRoutes.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showRoutes" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.highlightLargeFleets.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.highlightLargeFleets.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showLargeFleets" />
        </div>
      </div>
    </StandardCard>
    <StandardCard class="px-2 pb-2" top-padding="0">
      <div class="flex justify-between items-center">
        <div>
          <div class="font-bold">{{ t('map.settings.territoryOverlay.title') }}</div>
          <small class="text-gray-500">{{ t('map.settings.territoryOverlay.description') }}</small>
        </div>
        <div>
          <ToggleSwitch v-model="mapSettings.showTerritoryOverlay" />
        </div>
      </div>
      <div v-if="mapSettings.showTerritoryOverlay" class="mt-4">
        <div class="relative mb-6">
          <input
            type="range"
            id="territoryOpacity"
            min="5"
            max="60"
            step="5"
            v-model.number="mapSettings.territoryOpacity"
            class="w-full h-2 rounded-lg appearance-none cursor-pointer bg-gray-700"
          >
          <span class="text-subtext absolute start-0 -bottom-6">
            {{ t('map.settings.territoryOverlay.opacity') }}: <span class="text-slate-300">{{ mapSettings.territoryOpacity }}%</span>
          </span>
        </div>
      </div>
    </StandardCard>
  </SmallModel>
</template>
